module.exports = {"620802001":"东关街道","620802002":"中街街道","620802003":"西郊街道","620802101":"崆峒镇","620802102":"白水镇","620802103":"草峰镇","620802104":"安国镇","620802105":"柳湖镇","620802106":"四十里铺镇","620802107":"花所镇","620802203":"索罗乡","620802204":"香莲乡","620802205":"西阳乡","620802206":"大秦乡","620802207":"白庙乡","620802208":"寨河乡","620802209":"大寨乡","620802210":"上杨乡","620802211":"麻武乡","620802212":"峡门乡","620802498":"平凉崆峒山大景区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620802.json
// module id = 2924
// module chunks = 0